// The line under a form field that says what is wrong with it — a rule the
// form checks itself, or the server's answer placed by fieldErrors().

export function FieldError({ id, message }) {
  if (!message) return null;
  return (
    <p id={id} role="alert" className="text-xs text-red-600 dark:text-red-400">
      {message}
    </p>
  );
}

// A required field's label: a red asterisk drawn by CSS, so the label's text
// (what screen readers and getByLabelText read) stays the field's name; the
// input itself carries `required`.
export const REQUIRED_LABEL = "after:ml-0.5 after:text-red-600 after:content-['*'] dark:after:text-red-400";

export default FieldError;
